import React from 'react';

// One labelled field on a website form (the Trade Enquiry, the Contact
// page's enquiry form), styled by site.css's .ks-field.
function SiteField({ label, hint, children, htmlFor }) {
  return (
    <div className="ks-field">
      <label htmlFor={htmlFor}>{label}</label>
      {children}
      {hint && <p className="ks-field-hint">{hint}</p>}
    </div>
  );
}

export default SiteField;
